export const DefaultErrorLabel = 'Learn How To Qualify For Status';
export const SkyMilesMemberLabel = 'SkyMiles Member';
export const MyFlightPanelLabel = 'myFlightPanel';
export const LoadingLabel = 'Loading...';

export const enum TYPE {
  DELTA_360 = '360',
  MIN_LIMIT = '0',
  COMPLETE_LABEL = 'Complete',
  PENDING_EARNINGS = 'pending-earnings',
  QUALIFICATION_MILES = 'miles',
  QUALIFICATION_SEGMENTS = 'segments',
  QUALIFICATION_DOLLARS = 'dollars',
  QUALIFICATION_CARDS = 'cards',
  LOCALE = 'en-us',
  DIGITS_INFO = '1.0-0',
  OPTIONS_YEAR = 'numeric',
  OPTIONS_MONTH = 'short',
  OPTIONS_DEFAULT = 'default',
  NAME_PLACEHOLDER = '<NAME>',
  MONTH_PLACEHOLDER = '<Month>',
  YEAR_PLACEHOLDER = '<Year>',
  DATE_FORMAT = 'yyyy-MM-dd',
  X_PLACEHOLDER = '<X>',
  YEARS_LABEL = 'years',
  YEAR_LABEL = 'year',
  DEGREE = '°',
  REQUEST_TYPE = 'RETRIEVE_BYDOC_AND_COMBINE',
  APP = 'SKYMILES',
  CURRENCY_SYMBOL = '$',
  THOUSAND = 'k',
  TIME_ZONE = 'T12:00:00Z',
  MQD = 'MQDs',
  FUTURE = 'FUTURE',
  CURRENT = 'CURRENT',
  LIFETIME_MQM = 'LMQMs',
  AWARD_TRAVEL = 'award-travel',
  COMPLETE_PROFILE = 'complete-profile',
  EARNING_SIMPLER = 'earning-simpler',
  AVAIL = 'AVAIL',
  POSTED_ACTIVITY_COUNT = '${postedActivityCount}',
  MILLION_MILER = 'MM',
  DELTA_360_CODE = 'MV',
  TIER_CODE = 'MB',
  EDOCS_NO_DOCUMENT_CODE = 'PMT4170',
  NOT_APPLICABLE = 'N/A',
  DIAMOND_MEDALLION = 'DM',
  AIR_ACTIVITY_CODE = 'AA',
  ROLL = 'ROLL',
  ROLLOVER_MQM = 'Rollover MQMs',
  BEARER = 'Bearer',
  MEDALLION_STATUS = '[status]'
}

export type LevelType =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '17'
  | '18'
  | '19'
  | '20';

export const LEGEND_CLASS_NAMES: { [key: string]: string } = {
  'earned-skymiles': 'bg-loyalty-surface-tier-01-primary',
  'pending-skymiles': 'bg-member-50',
  'earned-silver': 'bg-loyalty-surface-tier-02-primary',
  'pending-silver': 'bg-silver-50',
  'earned-gold': 'bg-loyalty-surface-tier-03-primary',
  'pending-gold': 'bg-gold-50',
  'earned-platinum': 'bg-loyalty-surface-tier-04-primary',
  'pending-platinum': 'bg-platinum-50',
  'earned-diamond': 'bg-loyalty-surface-tier-05-primary',
  'pending-diamond': 'bg-diamond-50',
  'earned-360': 'bg-loyalty-surface-tier-06-primary',
  'pending-360': 'bg-delta-360-50'
};

export const ANALYTICS_DATA_NAMES = {
  event: 'Flyout-status-tracker-Modal-load',
  errorEventDetail: 'Flyout-Status-Tracker-Error',
  errorType: 'load-error',
  emptyString: ''
};
